import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { StudentsPlacedRoutingModule } from './hkbkplacements-students-placed-routing.module';
import { PlacementsStudentsPlacedListComponent } from './placements-students-placed-list/placements-students-placed-list.component';
import { PlacementsStudentsPlacedCreateComponent } from './placements-students-placed-create/placements-students-placed-create.component';

@NgModule({
  declarations: [PlacementsStudentsPlacedListComponent, PlacementsStudentsPlacedCreateComponent],
  imports: [
    CommonModule,
    StudentsPlacedRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class PlacementsStudentsPlacedModule { }
